import Disclaimer from '@/views/Disclaimer/index.vue'

const DisclaimerRouter = {
  path: '/disclaimer',
  name: 'Disclaimer',
  component: Disclaimer,
  props: (route) => ({
    secret: route.query.secret,
    token: route.query.token
  })
}

export default DisclaimerRouter
